export default "__VITE_ASSET__CKIrE2o6__"